module.exports = __webpack_public_path__ + "b44df783ec6179ed40a63bced27cf928.png";